export const getInitialValues = (data, type) => {
  if (data) return Object.fromEntries(
    data
      .find(group => group.name === type).non_savings_types
      .map(type => [type.name, true])
  );
  return {};
}